<template>
    <div class="project-view has-header">
        <div v-if="loading" class="loading-md bg">
            <i class="fas fa-spinner"></i>
            <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
                {{ loadingText }}
            </div>
        </div>
        <div class="header main">
            <div class = "align-left">
                <dateselectionheader
                             :label="dateDisplay"
                            @PrevDate="SelectPreviousDate"
                            @NextDate="SelectNextDate"
                            @CalendarOpen="toggleDatePicker"
                            @SetToday="SelectToday"/>
            </div>
            <div class = "align-middle">
                <headerbuttonstack :state="headerButtons"/>
            </div>
            <div class = "align-right">
            </div>
        </div>


        <div class="scrollbar-container">
            <div class="sub-header" v-if="displayedTimeframeSelected.label === 'M'">
                <div class="title" v-bind:style="{width: GetWidthFirstTitle()}">
                    <div class="label ">{{timeFrameStart.format("MMMM")}}</div>
                </div>

            </div>

            <div class="day-container hours" v-if="displayedTimeframeSelected.label === 'Y'">
                <div class="background"></div>
                <div class="day" v-for="(month, indexD) in monthsDisplayed" :key="indexD"  v-bind:style="[GetTimeMarkWidth(indexD)]">

                    <div class="day-text" v-on:click="SelectMonth(month)">
                        <div class="name">{{month.name}}
                        </div>

                    </div>

                </div>
            </div>
            <div class="day-container hours" v-if="displayedTimeframeSelected.label === 'M'">
                <div class="background"></div>
                <div class="day" v-for="(day, indexD) in daysDisplayed" :key="indexD"  v-bind:style="[GetTimeMarkWidth(indexD)]">

                    <div class="day-text">
                        <div class="name">{{day.name}}
                        </div>
                        <div class="date">{{day.date}}
                        </div>
                    </div>

                </div>
            </div>
            <div class="grid">

                <div class="header">
                    <div class="label">{{ $t('shift.plan.project') }}</div>
                     <!--
                    <div class="employee-filter button" v-on:click="OpenFilterPopup($event)">
                    <div class="label" style="padding-left: 4px; padding-top: 1px;">
                        <i class="fas fa-filter"></i>
                    </div>
                    </div>
                    -->

                </div>

                <div class="backdrop"></div>

                <div class="group" v-for="group in projectGroups" :key="group.id">
                    <div class="header" >

                        <div class="label">{{group.name}}</div>

                        <div class="fa-stack edit" v-on:click="OpenEditProjectGroupModal($event, group)" v-tooltip="$t('shift.plan.editProjectGroup')" v-if="group.id != 'default'">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-edit fa-stack-2x"></i>
                        </div>
                        <div class="fa-stack remove" v-on:click="OpenDeleteProjectGroupModal($event, group)" v-tooltip="$t('shift.plan.deleteProjectGroup')" v-if="group.id != 'default'">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-minus fa-stack-2x"></i>
                        </div>
                    </div>

                    <div class="row" v-for="(project) in projectsByGroupMap[group.id]" :key="project.id" >
                        <div class="project">
                            <div class="background" ></div>
                            <div class="background shadow" ></div>

                            <div class="name">{{project.name}} <i class="fas fa-circle" v-bind:style="{color: project.color }"></i></div>

                            <div class="entitled">
                                <div class="label" v-if="statsMode == 1">{{ $t('shift.plan.timeBudget') }}: {{ project.timeBudget > 0 ? (((projectStatsMap[project.id] ? (projectStatsMap[project.id].workTimeSum/60): 0) / project.timeBudget) *100).toFixed(2)+"%": '-'}}</div>
                                <div class="label" v-if="statsMode == 2">{{ $t('shift.plan.moneyBudget') }}: {{ project.moneyBudget > 0 ? (((projectStatsMap[project.id] ? (projectStatsMap[project.id].wageSum): 0) / (project.moneyBudget/Math.pow(10, 5))) *100).toFixed(2)+"%": '-'}}</div>

                            </div>

                            <div style= "width: 30px; height: 30px;">
                                    <div class="fa-stack detail"
                                    v-bind:style="{'z-index': 99}" v-on:click="OpenProjectButtonMenu($event, project)">
                                        <i style="font-size:25px; right:0px;" class="fas fa-circle fa-stack-2x"></i>
                                        <i style="font-size:25px; margin-left:-1px;" class="fas fa-cog fa-stack-2x"></i>
                                    </div>
                            </div>

                        </div>

                        <div class="timeframe" v-for="(timeFrame) in timeFrameMap[project.id]" :key="timeFrame.key" v-bind:style="[GetTimeFrameStyles(timeFrame)]" v-bind:id="timeFrame.project.id" v-tooltip="getProjectTooltip(timeFrame.project.id)"
                             v-on:mouseup="SelectTimeFrame($event, timeFrame)" v-on:mouseenter="CheckLabelLength($event)">
                            <div class="label">{{timeFrame.label}}</div>
                            <div class="shadow"></div>

                        </div>
                        <div class="top-line"></div>
                        <div class="bottom-line"></div>
                    </div>
                </div>
                <div class="time-marks" v-bind:class="{monthly: displayedTimeframeSelected.label === 'Y'}">
                    <div class="mark" v-for="(mark, indexMark) in timeMarks" v-bind:index="indexMark" :key="indexMark" v-bind:style="[GetTimeMarkWidth(indexMark)]" v-bind:class="{'day-split' : mark === '00'}">
                    </div>
                </div>
                <div class="time-marks labels" v-if="displayedTimeframeSelected.label === 'D'">
                    <div class="mark" v-for="(mark, indexMark) in timeMarks" v-bind:index="indexMark" :key="indexMark" v-bind:style="[GetTimeMarkWidth(indexMark)]" v-bind:class="{'day-split' : mark === '00'}">
                        <div class="label" v-if="displayedTimeframeSelected.label !== 'M'">{{displayedTimeframeSelected.label !== 'Y' ? mark : displayedTimeframeSelected.timeStart.clone().month(indexMark).format('MMM')}}</div>
                    </div>
                </div>
            </div>
        </div>



        <projectdetailmain ref="projectdetailpopup"></projectdetailmain>
    </div>
    <!-- <div class="app has-header">
        <div class="header main">

            <div class="align-left">

            </div>
            <div class="align-middle">
               <headerbuttonstack :state="headerButtons"/>
            </div>
            <div class="align-right">
            </div>
        </div>
        <div class ="tablecontainer scrollbar-container">
             <datatable :state="dataTableState"/>

        </div>


    <div v-if="loading" class="loading-md bg">
            <i class="fas fa-spinner"></i>
            <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
                {{ loadingText }}
            </div>
        </div>
  </div> -->

</template>

<script>

import { mapState, mapGetters } from 'vuex';
import projectdetailmain from '../shiftcontext/projectdetail/ProjectDetailMain.vue'
export default {
  name: 'projectoverview',
    components: {
        projectdetailmain,
    },
    data () {
        return {
            displayedTimeframes: [],
            displayedTimeframeSelected: null,
            timeFrameStart: this.$helpers.getMomentTZ().startOf('year'),
            timeFrameEnd: this.$helpers.getMomentTZ().startOf('year').add(1, 'year'),
            timeFrameLength: 365 * 24 * 60 * 60 * 1000,
            currentYear: this.$helpers.getCurrentMonthMomentTZ().year(),
            currentMonth: this.$helpers.getCurrentMonthMomentTZ().startOf('year').month(),
            currentDate: 1,
            statsMode: 1,
            planned: true,
            error: false,
            loading: true,
            loadingText: null,
            plannedProjectStatsMap: {},
            actualProjectStatsMap: {},
            monthsShort: {
                'Januar': this.$t('global.general.month1'),
                'Februar': this.$t('global.general.month2'),
                'März': this.$t('global.general.month3'),
                'April': this.$t('global.general.month4'),
                'Mai': this.$t('global.general.month5'),
                'Juni': this.$t('global.general.month6'),
                'Juli': this.$t('global.general.month7'),
                'August': this.$t('global.general.month8'),
                'September': this.$t('global.general.month9'),
                'Oktober': this.$t('global.general.month10'),
                'November': this.$t('global.general.month11'),
                'Dezember': this.$t('global.general.month12'),
            }
        }
    },
    created: function () {
        if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
            if(this.rosterFromTo != null){
                let startDate = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, 1, 1);
                this.onDatePicked(startDate, 'Y', 24);
            } else {
                this.onDatePicked(this.$helpers.getCurrentMonthMomentTZ(), 'Y', 24);
            }
        }
    },
    mounted: function() {
        this.refresh();
    },
    computed: {
        ...mapGetters(['storeId', 'projectMap', 'projectGroupMap', 'storeSettings', 'rosterFromTo']),
        dateDisplay: function() {
            if(this.timeFrameStart != null){
                if(this.displayedTimeframeSelected.label === 'D') return this.timeFrameStart.format('DD.MM.YYYY');
                if(this.displayedTimeframeSelected.label === 'M') return this.timeFrameStart.format('MMM YYYY');
                if(this.displayedTimeframeSelected.label === 'Y') return this.timeFrameStart.format('YYYY');
                return '-';
            } else {
                return '-';
            }

        },
        projectStatsMap(){
            return this.planned? this.plannedProjectStatsMap : this.actualProjectStatsMap;
        },
        daysDisplayed(){
            let days = [];
            let date = this.$helpers.getMomentTZ().date(this.currentDate).month(this.currentMonth).year(this.currentYear).minutes(0).seconds(0).milliseconds(0);
            for(let x = 0; x < date.daysInMonth(); x++){
                date.date(x + 1);
                days.push({
                    name: date.format('dddd').substring(0,2),
                    date: date.format('DD').substring(0,2) + '.' + date.format('MM').substring(0,2),
                    moment: date.clone(),
                });
            }
            return days;

        },
        monthsDisplayed(){
            let days = [];
            let date = this.$helpers.getMomentTZ().date(1).month(0).year(this.currentYear).minutes(0).seconds(0).milliseconds(0);
            for(let x = 0; x < 12; x++){

                days.push({
                    name: this.translateMonth(date.format('MMMM')),

                    moment: date.clone(),
                });
                date.add(1, 'months');
            }
            return days;

        },
        timeMarks(){

            let marks = [];

            let timeFrame = this.displayedTimeframeSelected;
            for(let x = 0; x < timeFrame.divisions; x++){
                let timemark = (x + 1 > 9 ? x + 1 : '0' + (x + 1));

                if(timeFrame.length <= 48 * 60 * 60 * 1000) timemark = ((x % 24) > 9 ? (x % 24) : '0' + (x % 24));

                marks.push(timemark.toString());
            }
            return marks;
        },
        headerButtons(){

            let view = this;

            let state= {
                buttons: []
            };
            //BUTTON 1
            if(this.displayedTimeframeSelected.label !=  'Y'){
                state.buttons.push({
                    type: "block border-r",
                    icon: "fa-chevron-left",
                    click: () => {view.onDatePicked(view.timeFrameStart.clone().startOf('year'), 'Y', 24);},
                    tooltip: this.$t('shift.groups.backToYear')
                });
            }
            state.buttons.push({
                type: "block",
                icon: "fa-sync-alt",
                click: () => {
                    view.refresh(true);
                },
                tooltip: this.$t('global.general.refreshData')
            });
            state.buttons.push({
                type: "block green",
                icon: "fa-plus",
                click: ($event) => {
                    view.OpenCreateProjectGroupModal($event);
                },
                tooltip: this.$t('shift.plan.addProjectGroup'),
                helperText: this.$t('shift.plan.addProjectGroupHelp'),
                externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/topic/b826791f-6f4d-4473-a65e-87eba3c3a7c5/article/2510454785"
            });
            state.buttons.push({
                type: "block border-r",
                icon: "fa-plus",
                click: ($event) => {
                    view.OpenCreateProjectModal($event);
                },
                tooltip: this.$t('shift.plan.addProject'),
                helperText: this.$t('shift.plan.addProjectHelp'),
                externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/topic/b826791f-6f4d-4473-a65e-87eba3c3a7c5/article/2510454785"
            });
            state.buttons.push({
                type: "block border",
                icon: view.statsMode == 1 ? "fa-clock" : "fa-coins",
                click: ($event) => {
                    if(view.statsMode == 1){
                        view.statsMode = 2
                    } else {
                        view.statsMode = 1;
                    }
                },
                tooltip: view.statsMode == 1 ? this.$t('shift.plan.showTimeBudget') : this.$t('shift.plan.showMoneyBudget'),
                helperText: this.$t('shift.plan.showBudgetHelp'),
                externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/topic/b826791f-6f4d-4473-a65e-87eba3c3a7c5/article/2510454785"
            });
            state.buttons.push({
                type: view.planned ? "block green" : "block orange",
                icon: "fa-clone",
                click: () => {
                    view.planned = !view.planned
                },
                tooltip: view.planned ? this.$t('shift.plan.showTargetData') : this.$t('shift.plan.showActualData'),
                helperText: this.$t('shift.plan.showDataHelp'),
                externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/topic/b826791f-6f4d-4473-a65e-87eba3c3a7c5/article/2510454785"
            });
            state.helperLinks = [
                    {
                        title:  this.$t('store.structure.getSupport'),
                        helperText:  this.$t('store.structure.getSupportHelp'),
                        externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/13",
                        externalLabel:  this.$t('store.structure.getSupportLabel'),
                        cancelLabel: this.$t('global.ui.close'),
                    }
                ];
            return state;
        },
        projectGroups(){
            let result = [{id: "default", name: this.$t('shift.plan.defaultGroup'), priority: 99999}];
            Object.values(this.projectGroupMap).forEach(pg => {
                result.push(pg);
            })
            result.sort((a, b) => {
                let order = a.priority - b.priority;
                if(order == 0){
                    return a.name.localeCompare(b.name);
                } else {
                    return order;
                }
            })
            return result;
        },
        projectGroupDropDownItems() {


            let items = Object.values(this.projectGroupMap).sort((a,b) => {
               return a.name.localeCompare(b.name);
            }).map(pg => {return {value: pg.id, label: pg.name}});
            items.push({value: null, label: this.$t('shift.plan.defaultGroup')});
            return items;

        },
        projectsByGroupMap(){
            let view = this;
            let map = {
                "default": [],
            }
            Object.values(this.projectGroupMap).forEach(pg => {
                map[pg.id] = [];
            })
            Object.values(this.projectMap).filter(proj => {
                let from = view.$helpers.getMomentFromStringTZ(proj.from);
                let to = view.$helpers.getMomentFromStringTZ(proj.to);
                return (from < view.timeFrameEnd && to > view.timeFrameStart)
            }).sort((a, b) =>  {
                let aFrom = view.$helpers.getMomentFromStringTZ(a.from);
                let bFrom = view.$helpers.getMomentFromStringTZ(b.from);

                return aFrom - bFrom;
            }).forEach(proj => {
                if(map[proj.groupId]){
                    map[proj.groupId].push(proj);
                } else {
                    map.default.push(proj);
                }
            });
            return map;
        },
        timeFrameMap(){
            let view = this;
            let map = {};
            const statsMap = this.projectStatsMap;
            const statsMode = this.statsMode;
            Object.values(this.projectMap).forEach(p => {
                if(!map[p.id]){
                    map[p.id] = [];
                }
                let pfrom = view.$helpers.getMomentFromStringTZ(p.from);
                let pto = view.$helpers.getMomentFromStringTZ(p.to);
                map[p.id].push({key: "tf-"+p.id, project: p, fromDate: pfrom, toDate: pto, statsFrame: false});
                if(statsMap[p.id]){
                    let stats = statsMap[p.id];
                    let sfrom = pfrom.clone();
                    let sto = pto.clone();
                    let hoursDiff = pto.diff(pfrom, 'hours');
                    let ratio = 1.0;
                    if(statsMode == 1 && p.timeBudget > 0){
                        let time = Math.round(stats.workTimeSum/60.0)
                        ratio = (time)/p.timeBudget;
                        sto = sfrom.clone().add(Math.round(hoursDiff * ratio), 'hours');
                        if(sto > pto){
                            sto = pto.clone();
                        }
                        map[p.id].push({key: "tf2-"+p.id, project: p, fromDate: sfrom, toDate: sto, statsFrame: true, over: time > p.timeBudget});
                    }
                    if(statsMode == 2 && p.moneyBudget > 0){
                        let money = stats.wageSum;
                        let budgetInCents = p.moneyBudget / Math.pow(10,5);
                        ratio = (money)/budgetInCents;
                        sto = sfrom.clone().add(Math.round(hoursDiff * ratio), 'hours');
                        if(sto > pto){
                            sto = pto.clone();
                        }
                        map[p.id].push({key: "tf2-"+p.id, project: p, fromDate: sfrom, toDate: sto, statsFrame: true, over: money > budgetInCents});
                    }
                }
            })
            return map;
        }
    },
    watch: {
        storeId: function(val, oldVal) {
            this.refresh(true);
        },
        rosterFromTo(newVal, oldVal) {
            if(newVal != null && this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
                this.refresh();

            }
        },
    },
  // methods that implement data logic.
    methods: {
        refresh: function(force = false) {
            let view = this;
            this.loading = true;
            let ids = [];
            this.$helpers.GetProjectGroupMap(force)
            .then(map => {
                return view.$helpers.GetProjectMap(force)
            })
            .then(map => {
                ids = Object.values(map).map(p => p.id);
                return view.loadActualProjectStats(ids);
            })
            .then(map => {
                return view.loadPlannedProjectStats(ids);
            })
            .then(map=>{
                view.loading = false;
            })
            .catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
                view.loading = false;
                console.log(error)
            });
        },
        translateMonth(val) {
            return this.monthsShort[val] || "In";
        },
        OpenProjectButtonMenu($event, project){
            let view = this;
            view.$helpers.OpenButtonContainer([
                {color: '', icon: 'fa-info', label: this.$t('shift.plan.info'), click: () => { view.OpenProjectInfo($event, project) }},
                {color: '', icon: 'fa-search', label: this.$t('global.general.details'), click: () => { view.OpenProjectDetails($event, project) }},
                {color: '#e5c420', icon: 'fa-edit', label: this.$t('global.ui.edit'), click: () => { view.OpenEditProjectModal($event, project) }},
                {color: '#e51650', icon: 'fa-trash', label: this.$t('global.ui.delete'), click: () => { view.OpenDeleteProjectModal($event, project) }},

            ], { elRelative: $event.currentTarget, offsetx: 5, offsety: -10, closeOnSelect: true })

        },
        OpenProjectDetails($event, project){

            let projectDetailState = {projectId: project.id, event: $event};
            this.$refs.projectdetailpopup.Init(projectDetailState);

        },
        OpenProjectInfo($event, project){
            let view = this;
            let from = view.$helpers.getMomentFromStringTZ(project.from).format("DD.MM.YYYY HH:mm");
            let to = view.$helpers.getMomentFromStringTZ(project.to).format("DD.MM.YYYY HH:mm");

            let plannedstats = view.plannedProjectStatsMap[project.id];
            let actualstats = view.actualProjectStatsMap[project.id];
            let dataEntries = [
                {label: this.$t('pages.employeeData.name'), key: 'name', disabled: true, hidden: false, type: 'text', value: project.name},
                {label: this.$t('global.general.from'), key: 'from', hidden: false, type: 'text', disabled: true, value: from},
                {label: this.$t('global.general.to'), key: 'to', hidden: false, type: 'text', disabled: true, value: to},
                {label: this.$t('shift.plan.timeBudget'), key: 'timeBudget', hidden: false, disabled: true, type: 'text', value: (project.timeBudget/60.0).toFixed(2)+"h"},
                {label: this.$t('shift.plan.plannedShifts'), key: 'plannedTime', hidden: false, disabled: true, type: 'text', value: plannedstats ? (plannedstats.workTimeSum/3600).toFixed(2)+"h" : '-'},
                {label: this.$t('shift.plan.punchTimes'), key: 'actualTime', hidden: false, disabled: true, type: 'text', value: actualstats ? (actualstats.workTimeSum/3600).toFixed(2)+"h" : '-'},

                {label: this.$t('shift.plan.moneyBudget'), key: 'moneyBudget', hidden: false, disabled: true, type: 'text', value: (project.moneyBudget/Math.pow(10,7)).toFixed(2)+"€"},
                {label: this.$t('shift.plan.plannedLaborCosts'), key: 'plannedMoney', hidden: false, disabled: true, type: 'text', value: plannedstats ? (plannedstats.wageSum/100).toFixed(2)+"€" : '-'},
                {label: this.$t('shift.plan.punchedLaborCosts'), key: 'actualMoney', hidden: false, disabled: true, type: 'text', value: actualstats ? (actualstats.wageSum/100).toFixed(2)+"€" : '-'},


            ];

            this.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    selectCallback: function (shift) {

                    }
                },
                header: this.$t('shift.plan.projectInfo'),
                pointerDirection: 1,
                expanded: true,
                centered: true,
            });
        },
        getProjectTooltip(projectId){
            let view = this;
            return () => {
                let project = view.projectMap[projectId];
                let stats = view.projectStatsMap[projectId];
                let prefix = "-";
                let suffix = "-";
                if(view.statsMode == 1){
                    suffix = (project.timeBudget/60.0).toFixed(2)+" h";
                    if(stats){
                        prefix = (stats.workTimeSum/3600.0).toFixed(2)
                    }
                }else if(view.statsMode == 2){
                    suffix = (project.moneyBudget/Math.pow(10,7)).toFixed(2)+" €";
                    if(stats){
                        prefix = (stats.wageSum/100.0).toFixed(2)
                    }
                }

                return prefix+" / "+suffix;
            }
        },
        loadPlannedProjectStats(projectids){
            let view = this;
            let url = '/api/sec/project/stats';
            let params = {
                storeId: this.storeId,
                planned: true

            }

            let payload = {
                storeId: this.storeId,
                ids: projectids
            }

            return new Promise((resolve, reject) => {
                view.axios({
                    method: 'post',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    params: params,
                    data: payload
                }).then(response => {
                    view.plannedProjectStatsMap = {};
                    response.data.forEach(s => {
                        view.plannedProjectStatsMap[s.id] = s;
                    })
                    resolve()
                }).catch(function (error) {
                    reject(error)
                })
            })

        },
        loadActualProjectStats(projectids){
            let view = this;
            let url = '/api/sec/project/stats';
            let params = {
                storeId: this.storeId,
                planned: false
            }

            let payload = {
                storeId: this.storeId,
                ids: projectids
            }

            return new Promise((resolve, reject) => {
                view.axios({
                    method: 'post',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    params: params,
                    data: payload
                }).then(response => {
                    view.actualProjectStatsMap = {};
                    response.data.forEach(s => {
                        view.actualProjectStatsMap[s.id] = s;
                    })
                    resolve()
                }).catch(function (error) {
                    reject(error)
                })
            })

        },
        GetWidthFirstTitle(){
            let width = 100;
            if(this.displayedTimeframeSelected.divisions === 36) width = 66.6666;
            if(this.displayedTimeframeSelected.divisions === 48) width = 50;
            width += '%';
            return width;
        },
        GetTimeMarkWidth(index) {

            let timeFrame = this.displayedTimeframeSelected;
            if(timeFrame.label === 'Y') {
                let lengthYear = timeFrame.length;
                let lengthMonth = timeFrame.timeStart.clone().month(index).daysInMonth() * 24 * 60 * 60 * 1000;
                let widthMonth =  lengthYear / lengthMonth;
                return {width: ($(this.$el).find('.time-marks').width() / widthMonth) + 'px'};
            }
            return {width: ($(this.$el).find('.time-marks').width() / parseInt(timeFrame.divisions)) + 'px'};
        },
        CheckLabelLength($event){
            let el = $event.currentTarget;
            let box = el.getBoundingClientRect();
            let boxlabel = el.querySelector('.label').getBoundingClientRect();
            if(boxlabel.width > box.width) el.classList.add('show-under');
            else el.classList.remove('show-under');
        },
        SelectTimeFrame($event, timeFrame){
            let view = this;
            let labelOptions = [];
            labelOptions.push({text: this.$t('shift.plan.info'), type: 'block', click: () => {
                view.OpenProjectInfo($event, timeFrame.project);
            }});
            labelOptions.push({text: this.$t('global.ui.edit'), type: 'block', click: () => {
                view.OpenEditProjectModal($event, timeFrame.project);
            }});
            labelOptions.push({text: this.$t('global.ui.delete'), type: 'block', click: () => {
                view.OpenDeleteProjectModal($event, timeFrame.project);
            }});

            this.$helpers.OpenListLabel(labelOptions,{allowOverflow: true});
        },
        GetTimeFrameStyles(timeFrame){

            let totalWidth = $(this.$el).find('.time-marks').width();
            let timePixelRatio = totalWidth / this.timeFrameLength;


            let background = timeFrame.statsFrame ?(timeFrame.over ?'#e51c50' : '#6d8d23') :'';
            let boxShadow = 'inset -5px 0 2px -2px ';
            let styles = {
                width: (this.TimeDiff(timeFrame.fromDate, timeFrame.toDate) * timePixelRatio) + 'px',
                'min-width': this.displayedTimeframeSelected.label !== 'D' ? ((8 * 60 * 60 * 1000) * timePixelRatio) + 'px' : '',
                left: (this.TimeDiff(this.timeFrameStart, timeFrame.fromDate) * timePixelRatio) + 'px',
                background: background,
                //'box-shadow': boxShadow,
            };
            return styles;
        },
        TimeDiff(a, b){
            return b._d.getTime() - a._d.getTime();
        },
        SelectToday(){
            let date = this.$helpers.getMomentTZ();
            this.onDatePicked(date, 'D', 36);

        },
        SelectMonth(month){
            this.onDatePicked(month.moment, 'M', 36);
        },
        SelectPreviousDate(){
            if(this.displayedTimeframeSelected.label === 'M'){
                let date = this.timeFrameStart.clone().add(-1, 'month');
                this.onDatePicked(date, 'M', 24);
            } else if(this.displayedTimeframeSelected.label === 'Y'){
                let date = this.timeFrameStart.clone().add(-1, 'year');
                this.onDatePicked(date, 'Y', 24);
            } else {
                let date = this.timeFrameStart.clone().add(-1, 'day');
                this.onDatePicked(date, 'D', this.displayedTimeframeSelected.divisions);
            }


        },
        SelectNextDate(){
            if(this.displayedTimeframeSelected.label === 'M'){
                let date = this.timeFrameStart.clone().add(1, 'month');
                this.onDatePicked(date, 'M', 24);
            } else if(this.displayedTimeframeSelected.label === 'Y'){
                let date = this.timeFrameStart.clone().add(1, 'year');
                this.onDatePicked(date, 'Y', 24);
            } else {
                let date = this.timeFrameStart.clone().add(1, 'day');
                this.onDatePicked(date, 'D', this.displayedTimeframeSelected.divisions);
            }

        },
        toggleDatePicker($event) {
            let view = this;
            let date = this.dateSelectionStart;

            this.$helpers.OpenDatepickerPopup(
                {viewsEnabled: ['Y'], selectedTab: this.displayedTimeframeSelected.label, date: date, hourlyEnabled: true, hourlySelection: [12, 24, 36], hourlySelected: view.hourlySelection},
                {
                    OnDateSelect: (date) => {

                    },
                    OnMonthSelect: (date) => {
                        view.onDatePicked(date, 'M');
                    },
                    OnDaySelect: (date, hours) => {
                        view.onDatePicked(date, 'D', hours);
                    },
                    OnYearSelect:  (date) => {
                        view.onDatePicked(date, 'Y');
                    }
                }, {elRelative: $event.currentTarget});
         },
        onDatePicked(date, timeFrameType, hours = 24){
            this.hourlySelection = hours;
            let before = this.timeFrameStart.clone();
            if(timeFrameType === 'Y'){
                this.timeFrameStart = date.clone().startOf('year');
            } else if(timeFrameType === 'M'){
                this.timeFrameStart = date.clone().startOf('month');
            } else {
                this.timeFrameStart = date.clone().startOf('day');
            }

            if(before.year() != this.timeFrameStart.year()){
                //month / year change => trigger reload
                let rosterDate = this.timeFrameStart.clone().startOf('month');
                this.setDateSelection(rosterDate, true);
            } else {
                this.setDateSelection(this.timeFrameStart, !this.rosterFromTo);
            }
            this.setDateSelection(this.timeFrameStart, false);
            let displayTimeFrame;
            if(timeFrameType === 'Y'){
                displayTimeFrame = {label: 'Y', length: this.$helpers.getMomentTZ().month(11).date(31).dayOfYear() * 24 * 60 * 60 * 1000, divisions: 12, timeStart: this.timeFrameStart.clone().month(0).date(1)};
            } else if (timeFrameType === 'M'){
                displayTimeFrame = {label: 'M', length: this.timeFrameStart.daysInMonth() * 24 * 60 * 60 * 1000, divisions: this.timeFrameStart.daysInMonth(), timeStart: this.timeFrameStart.clone().date(1)};
            } else {
                displayTimeFrame = {label: 'D', length: hours * 60 * 60 * 1000, divisions: hours, timeStart: this.timeFrameStart.clone()};
            }
            this.displayedTimeframes = [displayTimeFrame];
            this.timeFrameLength = displayTimeFrame.length;
            this.timeFrameEnd = this.timeFrameStart.clone().add(this.timeFrameLength, 'milliseconds');
            this.displayedTimeframeSelected = displayTimeFrame;


            this.$forceUpdate();

        },
        setDateSelection(date, calculateRosterFromTo){
            let fixedDate = this.$helpers.getMomentTZ().year(date.year()).month(date.month()).date(date.date()).startOf('day');
            this.dateSelectionStart = fixedDate;

            this.currentDate = date.date();
            this.currentMonth = date.month();
            this.currentYear = date.year();
            //if(this.displayedTimeframeSelected.label === 'D') this.displayedTimeframeSelected.timeStart = date.clone();

            if(calculateRosterFromTo){
                //update vuex store with calculated from to => triggers reload of data via refresh

                let rosterFromTo = this.$helpers.CalculateRosterFromTo(date);
                this.$store.commit('setRosterFromTo', {rosterFromTo: rosterFromTo});
            } else {
                //dont update vuex from to, only update client side view
            }
        },
        OpenCreateProjectGroupModal($event){
            let view = this;

            view.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: [
                        {label: this.$t('pages.employeeData.name'), key: 'name', hidden: false, type: 'text', value: "Projekt", flexGroup: false},
                        {label: this.$t('shift.plan.sortPriority'), key: 'priority', hidden: false, type: 'slider', value: 1,
                            slider: {value: 1, min: 1, max: 100, inputControl: true, sliderInput: (x) => {return x}}},
                    ],
                    errorCheck: [

                    ],
                    selectCallback: function (item) {

                        view.createProjectGroup(item);
                    }
                },
                header: this.$t('shift.plan.addProjectGroup'),
                width: '700px',
                centered: true,
                expanded: true,
            });
        },
        createProjectGroup: function(item){
            let view = this;
            let url = '/api/sec/projectgroup';
            let params = {
                storeId: this.storeId,
            }

            let payload = {
                name: item.name,
                priority: item.priority,
            }


            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                view.$store.commit("setProjectGroupMapEntry", response.data.data);
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('shift.plan.projectGroupAdded'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.plan.addProjectGroupError'));
                console.log(error)
            })

        },

        OpenDeleteProjectGroupModal($event, data){
            let view = this;
            view.$helpers.OpenAlert({header: this.$t('shift.plan.deleteProjectGroup'), description: this.$t('shift.plan.deleteProjectGroupQuery', [data.name]), callbackAccept: (alert) => {
                alert.hidden = true;
                view.deleteProjectGroup(data);
            }});
        },
        deleteProjectGroup: function(item){
            let view = this;
            let url = '/api/sec/projectgroup';
            let params = {
                id: item.id,
                storeId: this.storeId,
            }


            this.axios({
                method: 'delete',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                params: params,
                url: url
            }).then(response => {
                view.$store.commit("deleteProjectGroupMapEntry", {id: item.id});
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('shift.plan.projectGroupDeleted'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.plan.deleteProjectGroupError'));
                console.log(error)
            })

        },
        OpenEditProjectGroupModal($event, item){
            let view = this;

            this.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: [
                        {label: 'Id', key: 'id', hidden: true, type: 'text', value: item.id, flexGroup: false},
                        {label: this.$t('pages.employeeData.name'), key: 'name', hidden: false, type: 'text', value: item.name, flexGroup: false},
                        {label: this.$t('shift.plan.sortPriority'), key: 'priority', hidden: false, type: 'slider', value: item.priority,
                            slider: {value: item.priority, min: 1, max: 100, inputControl: true, sliderInput: (x) => {return x}}},
                    ],
                    errorCheck: [

                    ],
                    selectCallback: function (item) {

                        view.editProjectGroup(item);
                    },

                },
                header: this.$t('shift.plan.editProjectGroup'),
                width: '700px',
                centered: true,
                expanded: true,
            });
        },
        editProjectGroup: function(item){
            let view = this;
            let url = '/api/sec/projectgroup';
            let params = {

                storeId: this.storeId,
            }

            let payload = {
                id: item.id,
                name: item.name,
                priority: item.priority,
                updateFields: ["name", "priority"]
            }

            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                let data = view.projectGroupMap[item.id]
                data.name = payload.name;
                data.priority = payload.priority;



                view.$store.commit("setProjectGroupMapEntry", data);
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('shift.plan.projectGroupEdited'));
            }).catch(function (error) {
               view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.plan.editProjectGroupError'));
               console.log(error)
            })

        },
        OpenCreateProjectModal($event){
            let view = this;
            let from = this.$helpers.getMomentTZ().startOf('day');
            let to = from.clone().add(1, 'days');
            let projectgroupitems = this.projectGroupDropDownItems;
            view.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: [
                        {label: this.$t('pages.employeeData.name'), key: 'name', hidden: false, type: 'text', value: "Projekt", flexGroup: false},
                        {label: this.$t('shift.plan.selectProjectColor'), key: 'color', hidden: false, type: 'color', value: view.$helpers.getRandomLightColor(), colorBlacklist: []},
                        {label: this.$t('shift.plan.projectGroup'), key: 'groupId', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: projectgroupitems,
                            selectMultiple: false,
                            selectedItems: [],
                            selectedItem: {},
                            onceSelected: function ($event, item, searchbar){
                            },
                            styleLight: true,
                            placeholder: this.$t('shift.plan.selectProjectGroup'),
                        }, styles: {width: '442px'}},
                        {label: this.$t('global.general.from'), key: 'from', hidden: false, type: 'date', value: from, flexGroup: true, styles:{'margin-right' : '10px'}},
                        {label: this.$t('global.general.to'), key: 'to', hidden: false, type: 'date', value: to, flexGroup: true},
                        {label: this.$t('shift.plan.timeBudget') + this.$t('indicator.crew.hourBubble'), key: 'timeBudget', hidden: false, type: 'text', value: '0.0'},
                        {label: this.$t('shift.plan.moneyBudget') + ' (€)', key: 'moneyBudget', hidden: false, type: 'text', value: '0.0'}
                    ],
                    errorCheck: [
                        (entries) => {
                            let fValue = parseFloat(entries["timeBudget"]);
                            if(isNaN(fValue) || fValue == null || fValue == Infinity || fValue < 0){
                                return {key: 'timeBudget', type: 'error', label: this.$t('shift.plan.timeBudget'), text: 'Der Wert muss eine gültige Zahl größer 0 sein!'}
                            } else {
                                return null
                            }
                        },
                        (entries) => {
                            let fValue = parseFloat(entries["moneyBudget"]);
                            if(isNaN(fValue) || fValue == null || fValue == Infinity || fValue < 0){
                                return {key: 'moneyBudget', type: 'error', label: this.$t('shift.plan.moneyBudget'), text: 'Der Wert muss eine gültige Zahl größer 0 sein!'}
                            } else {
                                return null
                            }
                        },
                    ],
                    selectCallback: function (item) {

                        view.createProject(item);
                    }
                },
                header: this.$t('shift.plan.newProject'),
                centered: true,
                expanded: true,
            });
        },
        createProject: function(item){
            let view = this;
            let url = '/api/sec/project';
            let params = {
                storeId: this.storeId,
            }

            let payload = {
                name: item.name,
                from: item.from.startOf('day').format(),
                to: item.to.startOf('day').format(),
                color: item.color,
                groupId: item.groupId,
                timeBudget: Math.round(parseFloat(item.timeBudget)*60),
                moneyBudget: Math.round(parseFloat(item.moneyBudget)*Math.pow(10,7)),
            }


            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                view.$store.commit("setProjectMapEntry", response.data.data);
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('shift.plan.projectAdded'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.plan.addProjectError'));
                console.log(error)
            })

        },

        OpenDeleteProjectModal($event, data){
            let view = this;
            view.$helpers.OpenAlert({header: this.$t('shift.plan.deleteProject'), description: this.$t('shift.plan.deleteProjectQuery', [data.name]), callbackAccept: (alert) => {
                alert.hidden = true;
                view.deleteProject(data);
            }});
        },
        deleteProject: function(item){
            let view = this;
            let url = '/api/sec/project';
            let params = {
                id: item.id,
                storeId: this.storeId,
            }


            this.axios({
                method: 'delete',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                params: params,
                url: url
            }).then(response => {
                view.$store.commit("deleteProjectMapEntry", {id: item.id});
                view.$store.commit("invalidateState", {states: ['planShiftMapState', 'shiftTemplateMapState']});
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('shift.plan.projectDeleted'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.plan.deleteProjectError'));
                console.log(error)
            })

        },
        OpenEditProjectModal($event, item){
            let view = this;
            let from = this.$helpers.getMomentFromStringTZ(item.from);
            let to = this.$helpers.getMomentFromStringTZ(item.to);
            this.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: [
                        {label: 'Id', key: 'id', hidden: true, type: 'text', value: item.id, flexGroup: false},
                        {label: this.$t('pages.employeeData.name'), key: 'name', hidden: false, type: 'text', value: item.name, flexGroup: false},
                        {label: this.$t('shift.plan.selectProjectColor'), key: 'color', hidden: false, type: 'color', value: item.color, colorBlacklist: []},

                        {label: this.$t('global.general.from'), key: 'from', hidden: false, type: 'date', value: from, flexGroup: true, styles:{'margin-right' : '10px'}},
                        {label: this.$t('global.general.to'), key: 'to', hidden: false, type: 'date', value: to, flexGroup: true},
                        {label: this.$t('shift.plan.timeBudget') + this.$t('indicator.crew.hourBubble'), key: 'timeBudget', hidden: false, type: 'text', value: ((item.timeBudget != null ? item.timeBudget: 0)/60).toFixed(2)},
                        {label: this.$t('shift.plan.moneyBudget') + ' (€)', key: 'moneyBudget', hidden: false, type: 'text', value: ((item.moneyBudget != null ? item.moneyBudget: 0)/Math.pow(10,7)).toFixed(2)}
                    ],
                    errorCheck: [
                        (entries) => {
                            let fValue = parseFloat(entries["timeBudget"]);
                            if(isNaN(fValue) || fValue == null || fValue == Infinity || fValue < 0){
                                return {key: 'timeBudget', type: 'error', label: this.$t('shift.plan.timeBudget'), text: 'Der Wert muss eine gültige Zahl größer 0 sein!'}
                            } else {
                                return null
                            }
                        },
                        (entries) => {
                            let fValue = parseFloat(entries["moneyBudget"]);
                            if(isNaN(fValue) || fValue == null || fValue == Infinity || fValue < 0){
                                return {key: 'moneyBudget', type: 'error', label: this.$t('shift.plan.moneyBudget'), text: 'Der Wert muss eine gültige Zahl größer 0 sein!'}
                            } else {
                                return null
                            }
                        },
                    ],
                    selectCallback: function (item) {

                        view.editProject(item);
                    },

                },
                header: this.$t('shift.plan.editProject'),
                centered: true,
                expanded: true,
            });
        },
        editProject: function(item){
            let view = this;
            let url = '/api/sec/project';
            let params = {

                storeId: this.storeId,
            }

            let payload = {
                id: item.id,
                name: item.name,
                from: item.from.startOf('day').format(),
                to: item.to.startOf('day').format(),
                timeBudget: Math.round(parseFloat(item.timeBudget)*60),
                moneyBudget: Math.round(parseFloat(item.moneyBudget)*Math.pow(10,7)),
                color: item.color,
                updateFields: ["name", "from", "to", "timeBudget", "moneyBudget", "color"]
            }

            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                let data = view.projectMap[item.id]
                data.name = payload.name;
                data.from = payload.from;
                data.to = payload.to;
                data.color = payload.color;
                data.timeBudget = payload.timeBudget;
                data.moneyBudget = payload.moneyBudget;


                view.$store.commit("setProjectMapEntry", data);
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('shift.plan.projectEdited'));
            }).catch(function (error) {
               view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.plan.editProjectError'));
               console.log(error)
            })

        }


    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .header .add{
        position:absolute;
        top: -0px;
        right: 22px !important;
        transform: scale(0.55)  !important;
        cursor: pointer;
    }

    .header .edit{
        position:absolute;
        top: -0px;
        right: 6px !important;
        transform: scale(0.55) !important;
        cursor: pointer;
    }

    .header .edit .fa-edit {
        transform: scale(0.5);
    }

    .header .remove .fa-circle {
        color: #e51c50 !important;
    }
    .project-view{
        position: relative;
    }

    .project-view > .header{
        background: var(--contrast-1);
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 60px;
        text-align: center;
        z-index: 2;

    }
    .project-view > .header > * {
        display: inline-flex;
        align-items: center;
    }

    .project-view > .header {
        justify-content: center;

    }
    .project-view > .header > .button.filter{

        float: initial;
        margin: 0 10px;
        transform: translateY(1px);

    }

    .options{
        display: inline-block;
    }

    .options .label{
        text-align: center;
        border-radius: 5px;
        transition: .2s;
        height: 25px;
        width: 35px;
        border: 1px solid var(--contrast-5);
        border-right: none;
        border-radius: 0;
        line-height: 190%;
        cursor: pointer;
    }
    .options .label:first-child{
        border-radius: 5px 0 0 5px;
    }
    .options .label:last-child{
        border-radius: 0 5px 5px 0;
        border-right: 1px solid var(--contrast-5);
    }
    .options .label.selected, .options .label:hover{
        background: #6d8d23;
        color: white;
    }

    .grid{
        padding-top: 40px;
        text-align: center;
        position: relative;
        height: 100%;
    }

    .grid > .header{
        position: fixed;
        top: 145px;
        left: 6px;
        width: 100%;
        z-index: 20;
        padding-left: 10px;
    }

    .group{
        margin-bottom: 10px;
    }

    .group > .header{
        width: 255px;
        height: 19px;
        background: #6d8d23;
        border-top-left-radius: 50px;
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
        border-bottom-left-radius: 50px;
        position: relative;
        z-index: 2;
        margin-left: 5px;
    }

    .group > .header .label{
        color: white;
        font-size: 13px;
        padding-left: 20px;
    }
    .group.group-null > .header .label{
        padding-left: 10px;
    }



    .group > .header .fa-stack{
        position: absolute;
        right: -10px;
        transform: scale(0.55);
        top: -4px;
        margin: 0;
        cursor: pointer;
    }


    .group > .header .fa-stack > *{
        pointer-events: none;
    }

    .group > .header .fa-stack.add{
        right: 6px;
    }
    .group > .header .fa-stack *:not(.fa-circle){
        color: #6d8d23;
    }
    .group > .header .fa-stack .fa-circle{
        color: #e5e5e5;
    }
    .group > .header .fa-stack:hover .fa-circle{
        color: #707070 !important;
    }
    .group > .header .fa-stack:hover *:not(.fa-circle):not(.fa-arrows-alt){
        color: #e5e5e5 !important;
    }
    .group > .header .fa-stack.drag{
        right: initial;
        left: -10px;
    }
    .group > .header .fa-stack.drag .fa-arrows-alt{
        line-height: 130%;
        font-size: 20px;
        color: white;
    }

    .group > .header .fa-stack.drag .fa-circle{
        display: none;
    }


    .project .fa-stack{

        position: absolute;
        right: 10px;
        top: 0;
        bottom: 0;
        margin: auto;
    }
    .project:hover .fa-stack.detail{
        opacity: 1;
    }
    .project .fa-stack.detail{
         opacity: 1;
        cursor: pointer;
        font-size:25px;
        width:25px;
        height:25px;
        right:5px;
    }

    .project .fa-stack.detail:hover .fa-circle{
        color: #6d8d23 !important;
    }

    .project .fa-stack.detail:hover .fa-map{
        color: #404040 !important;
    }

    .project .fa-stack > .fas:not(.fa-circle){
        transform: scale(.55);
    }


    .row{
        position: relative;
        width: calc(100% - 215px);
        padding: 5px;
        margin-left: 260px;
        height: 45px;
    }

    .grid .project{
        position: absolute;
        top: 0;
        left: -245px;
        height: 46px;
        margin-bottom: 5px;
        padding-left: 45px;
        width: 245px;
        box-shadow: inset 0px -2px 0 -1px var(--contrast-1);
        z-index: 12;
    }

    .project .picture {
        background-size: 100%;
        position: absolute;
        height: 30px;
        width: 30px;
        left: 5px;
        top: 7px;
        border-radius: 33px;
    }

    .project .name {
        font-size: 13px;
        color: var(--contrast-5);
        text-align: left;
        height: 20px;
        white-space: nowrap;
        font-weight: 800;
        margin-top: 5px;
        margin-left: 0px;
        font-family: DistrictProBold;
        max-width: 100%;
        overflow: hidden;
    }

    .project .name.shadow{
        height: 15px;
        white-space: nowrap;
        width: 30px;
        box-shadow: inset -30px 0 7px -7px var(--bg) !important;
        position: absolute;
        right: 0;
        top: 0;
    }

    .project .buttons {
        font-size: 13px;
    }

    .project .buttons .first{
        position: absolute;
        top: 3px;
    }

    .project .buttons .second{
        position: absolute;
        top: 6px;
    }
    .row:hover .project .name.shadow{
        box-shadow: inset -30px 0 7px -7px var(--contrast-2) !important;
    }
    .project .progress {
        position: absolute;
        width: calc(100% - 45px);
        margin: auto;
        top: 30px;
        height: 6px;
        border-radius: 100px;
        background: var(--contrast-6);
        left: 45px;
        overflow: hidden;
    }

    .project .entitled {
        position: absolute;
        width: calc(100% - 45px);
        margin: auto;
        top: 22px;
        height: 24px;
        left: 45px;
        overflow: hidden;
    }

    .project .entitled .label{
        float: left;
        font-size: 12px;
        color: var(--contrast-5);
    }

    .project .progress .progress-bar {
        position: absolute;
        width: 00%;
        bottom: 00px;
        height: 100%;
        border-radius: 100px;
        background: var(--contrast-5);
        left: 0;
    }

    .project .progress .progress-bar{
    }


    .project .add{
        position:absolute;
        top: -0px;
        right: -5px;
        transform: scale(0.4);
        cursor: pointer;
    }
    .project .add .fa-plus{
        transform: scale(0.8);
    }

    .project .remove, .project .edit{
        position: absolute;
        right: 5px;
        top: 1px;
        margin: 0;
        transform: scale(0.65);
        cursor: pointer;
    }

    .project .edit1, .project .edit2{
        position: absolute;
        right: 5px;
        top: 1px;
        margin: 0;
        transform: scale(0.65);
        cursor: pointer;
    }

    .project .edit1 {
        position: absolute;
        right: 100px;
    }
    .project .edit2 {
        position: absolute;
        right: 80px;
    }
    .project .edit {
        position: absolute;
        right: 25px;
    }

    .project .remove .fa-minus {
        transform: scale(0.7);
    }
    .project .edit .fa-edit {
        transform: scale(0.5);
    }
    .project .edit1 .fa-edit {
        transform: scale(0.5);
    }
    .project .edit2 .fa-pencil-alt {
        transform: scale(0.6);
    }


    .project .edit .fa-copy {
          transform: scale(0.6);
      }
    .project .remove .fa-circle {
        color: #e51c50;
    }


    .event-info, .timeframe-popup, .drag-info, .drag-group{
        position: fixed;
        margin: auto;
        display: inline-block;
        background: var(--bg);
        box-shadow: 4px 4px 5px 3px rgba(0,0,0,0.2);
        pointer-events: none;
        width: fit-content;
        padding: 5px;
        border-radius: 5px;
        opacity: 1;
        z-index: 20;
    }

    .drag-info .description{
        color: var(--contrast-4);
        z-index: 20;
    }

    .drag-group{
        background: none;
        box-shadow: none;
        z-index: 100;
        pointer-events: none;
    }

    .event-info .header{
        position: relative;
        width: 100%;
        font-weight: 600;
        text-align: center;
    }

    .event-info .description{
        position: relative;
        width: 100%;
        text-align: center;
    }
    .timeframe-popup{
        pointer-events: initial;
        z-index: 11;
    }

    .timeframe-popup .button{
        position: relative;
        font-weight: 600;
        text-align: center;
        margin: 5px 15px;
        width: 120px;
        display: block;
        height: 18px;
        border-radius: 100px;
        line-height: 100%;
    }

    .timeframe-popup .background {
        position: fixed;
        height: 100vh;
        width: 100vw;
        left: 0;
        right: 0;
        z-index: -1;
        top: 0;
    }



    .time-marks{
        pointer-events: none;
        position: fixed;
        left: 260px;
        top: 200px;
        width: calc(100% - 278px);
        height: 100%;
        z-index: 10;
        padding: 0;
        white-space: nowrap;
    }

    .time-marks .label{
        position: absolute;
        top: -20px;
        left: -15px;
        width: 30px;
        text-align: center;
    }


    .time-marks.labels{
        z-index: 13;
    }

    .time-marks .mark{
        text-align: center;
        position: relative;
        width: calc(100% / 24);
        height: 100%;
        display: inline-block;
        box-shadow: inset 2px 0px 0 -1px  var(--contrast-1);
        background: none;
    }


    .time-marks .mark.day-split{
        box-shadow: inset 3px 0px 0 -1px  var(--contrast-4);
    }



    .time-marks.labels .mark{
        z-index: 13;
        height: 20px;;
    }

    .timeframe{
        position: absolute;
        height: calc(100% - 10px);
        background: #cccccc;
        z-index: 11;
        /*border-radius: 5px; */
        cursor: pointer;
        min-width: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .timeframe:hover{
        overflow: visible;
    }

    .timeframe .label{
        color: white;
        white-space: nowrap;
        position: absolute;
        left: 5px;
        right: 5px;
        margin: auto;
        text-align: center;
        pointer-events: none;
        width: auto;
        overflow: hidden;
    }


    .timeframe .shadow{
        position: absolute;
        left: 0;
        top: 0;
        pointer-events: none;
        width: 100%;
        height: 100%;
        box-shadow: inherit !important;
        border-radius: 5px;
        z-index: -2;
    }

    .timeframe.show-under:hover .label{
        left: -1000px;
        right: -1000px;
        bottom: -25px;
        background: inherit;
        padding: 1px 5px;
        z-index: 10;
        width: fit-content;
        display: inline-block;
        border-radius: 5px;
    }

    .timeframe .handle{
        position: absolute;
        top: 0;
        bottom: 0;
        height: 100%;
        width: 15px;
        margin: auto;
        cursor: col-resize;
        color: #9f9f9f;
        text-align: center;
        transition: .2s;
        opacity: 0;
    }


    .timeframe .handle .inner{
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        background: #9f9f9f;
        width: 2px;
        height: calc(100% - 20px);
        pointer-events: none;
    }

    .timeframe:hover .handle{
        opacity: 1;
    }

    .handle.start{
        left: -12px;

    }

    .handle.end{
        right: -12px;
    }
    .timeframe .handle.end{
    }

    .grid .backdrop{
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 260px;
        background: var(--bg);
        /*-webkit-box-shadow: 0 0 30px  var(--bg);
        box-shadow: 0 0 15px 10px  var(--bg);*/
        z-index: 2;
        pointer-events: none;
    }

    .scrollbar-container{
        width: 100%;
        overflow-x: hidden;
        padding-top: 37px;
    }
    .loading{
        filter: none !important;
        position:absolute;
        box-sizing:content-box;
        top: 0;
        left: 0;
        width: 100%;
        height: calc(100vh);
        background: rgba(0,0,0,.5);
        z-index: 100;
    }
    .loading .fa-spinner{
        position:absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 50px;
        height: 50px;
        font-size: 50px;
        color: var(--contrast-3);
        animation-name: spin;
        animation-duration: 2000ms;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
    }
    @keyframes spin {
        from {
            transform:rotate(0deg);
        }
        to {
            transform:rotate(360deg);
        }
    }

    .row .bottom-line,.row .top-line{
        box-shadow: inset 0px 2px 0 -1px  var(--contrast-1);
        height: 1px;
        position: absolute;
        bottom: 0px;
        width: calc(100% + 245px);
        left: -245px;
    }

    .row .top-line{
        bottom: initial;
        top: 0px;
        display: none;
    }

    .row:nth-child(4) .top-line{
        display: initial;
    }

    .fa-refresh:before{
        content: '\f021';
    }

    .group.show-drag-area:not(.group-dragged){
        padding-top: 20px;
        margin-top: 5px;
    }
    .group .drag-catch-area{
        display: none;
    }
    .group .drag-catch-area.last{
        display: none;
    }

    .group.show-drag-area:not(.group-dragged) .drag-catch-area{
        display: inline-block;
        width: 230px;
        height: 19px;
        left: 5px;
        margin-top: -45px;
        background: none;
        border: dashed 1px var(--contrast-5);
        border-radius: 50px;
        position: absolute;
        z-index: 5;
        font-size: 13px;
        color: transparent;
        text-align: left;
        padding-left: 25px;
    }

    .group.show-drag-area:not(.group-dragged) .drag-catch-area:hover{
        background: var(--contrast-2);
        border: solid 1px var(--contrast-5);
        color: var(--contrast-4);
        line-height: 16px;
        font-weight: 600;
    }
    .group .drag-catch-area.last{
        display: none !important;
    }
    .group.show-drag-area-last
    {
        padding-bottom: 20px;
    }
    .group.show-drag-area-last .drag-catch-area.last{
        display: inline-block !important;
    }
    .group.show-drag-area:not(.group-dragged) .drag-catch-area.last{
        margin-top: 4px;
    }

    .group.sub-spot.show-drag-area:not(.group-dragged) .drag-catch-area{
        width: 210px;
        left: 25px;
    }

    .group.sub-spot.show-drag-area:not(.group-dragged) .drag-catch-area:hover{
        background: var(--contrast-2);
        border: solid 1px var(--contrast-5);
        color: var(--contrast-4);
        line-height: 16px;
        font-weight: 600;
    }


    .group.show-drag-area:not(.group-dragged) .header{
        background: var(--contrast-6);
    }

    .group-dragged{
        opacity: .5;
    }

    .group.sub-spot > .header{
        width: 235px;
        margin-left: 25px;
    }

    .group.sub-spot .project{
        width: 225px;
        left: -225px;
    }


    .positions-filter, .project-filter {
        position: absolute;
        top: 4px;
        left: 208px;
        z-index: 3;
    }

    .project-filter {
        /*left: 80px;*/
    }

    .header > .filter.arrow.left{
        margin-right: 0;
    }

    .header > .filter.arrow.right{
        margin-left: 0;
    }
    .header > .filter.arrow{
        justify-content: center;
        height: 20px;
        width: 20px;
    }

    .filter.arrow .fas{
        transform: none;
        align-self: center;
    }



    .time-marks.monthly  .label{
        position: absolute;
        display: block;
        top: -14px;
        left: 0;
        right: 0;
        text-align: center;
        width: 100%;
        bottom: initial;
        height: 34px;
        line-height: 35px;
        cursor: pointer;
    }

    .day-container{
        height: 80px;
        width: calc(100% - 278px);
        white-space: nowrap;
        position: fixed;
        left: 260px;
        top: calc((2 * var(--header-height)) + var(--tab-menu-height) + 21px); /* 14px is the space needed to fit the weather and filter button */
        z-index: 12;
        background: var(--bg);
        overflow: hidden;
    }

    .day-container .day{
        transition: .2s;
        transform: scale(1);
        position: relative;
        opacity: 1 !important;
        padding-bottom: 0;
        height: 75px;
        width: 40px;
        margin: 0;
        cursor: pointer !important;
        top: 11px;
        z-index: 10;
        display: inline-block;
        box-shadow: inset 2px 0px 0 -1px #d5d5d5, inset 0px 0px 0 -1px #d5d5d5;
        border-radius: 0;
    }

    .day-container .day .name{
        position: absolute;
        height: 50%;
        width: 100%;
        left: 0;
        bottom: 0;
        right: 0;
        top: -10px;
        margin: auto;
        text-align: center;
        font-size: 13px;
        font-weight: 600;
        color: var(--contrast-4);
        border-radius: 0 !important;
        padding-top: 0 !important;
        background: none !important;
        cursor: pointer;
    }
    .day-container .day .date {

        position: absolute;
        height: 50%;
        width: 100%;
        left: 0;
        bottom: -20px;
        right: 0;
        top: 0;
        margin: auto;
        text-align: center;
        font-size: 10px;
        padding-top: 0 !important;
        border-radius: 0 !important;
        background: none !important;
        color: var(--contrast-4);
        cursor: pointer;
    }

    .day-container .day .income {
        width: calc(100% + 0px);
        position: absolute;
        bottom: 05px;
        font-size: 10px;
        background: transparent;
        height: 21px;
        padding-top: 3px;
        text-align: center;
        z-index: -1;
        cursor: pointer;
        box-shadow: inset 0px 2px 0 -1px #d5d5d5;
    }
    .day-container .day .weather {
        width: calc(100% + 1px);
        position: absolute;
        top: -16px;
        font-size: 10px;
        background: var(--bg);
        height: 25px;
        left: -1px;
        padding-top: 3px;
        padding-left: 1px;
        text-align: center;
        z-index: -1;
        cursor: pointer;
    }
    .day-container .day .weather .label{
        font-family: DistrictProLight;
        pointer-events: none;
        font-weight: 200;
        color: var(--contrast-4);
    }
    .day-container .day .weather .picture{

        width: 15px;
        margin-top: 2px;
        margin-left: 5px;
        height: 15px;
        display: inline-block;
        pointer-events: none;
        float: left;
    }
    .day-container .day:first-child .income {
        width: calc(100% + 1px);
        left: -1px;
    }
    .day-container .day .income .income-bar {
        position: absolute;
        border-radius: 100px;
        height: 8px;
        left: 5px;
        top: 9px;
        pointer-events: none;
    }
    .day-container .day .income .income-bar.red{
        background: #e51c50;

    }
    .day-container .day .income .income-bar.gray{
        background: var(--contrast-3);
    }

    .day-container .day .income .income-bar.green{
        background: #6d8d23;
    }

    .day-container-selected{
        position: fixed;
        top: 62px;
        left: 0px;
        margin: 0;
        z-index: 10000 !important;
        background: var(--bg);
        border-radius: 0;
        width: 90px;
    }

    .day-container-selected .day{

        position: fixed;
        left: 0px;
        margin: 0;
        margin-top: -5px;
        z-index: 10000 !important;
        background: var(--bg);
        border-radius: 0;
        width: 90px;
        height: 40px;
        top: 121px;
        cursor: pointer;
    }

    .day-container-selected .day *{
        pointer-events: none;
    }
    .day-container-selected .day .shadow{

        position: absolute;
        height: 40px;
        width: 140px;
        -webkit-box-shadow: 0 0 1px 0 #808080;
        box-shadow: 0 0 1px 0 #808080;
        left: -50px;
        top: 0;
    }

    .day-container-selected .day .name{

        position: absolute;
        height: 50%;
        width: 100%;
        left: 0;
        bottom: 0;
        right: 0;
        top: -10px;
        margin: auto;
        text-align: center;
        font-size: 13px;
        font-weight: 600;
        color: var(--contrast-4);
        border-radius: 0 !important;
        padding-top: 0 !important;
        background: none !important;
        cursor: pointer;
    }


    .day-container-selected .day .date{
        position: absolute;
        height: 50%;
        width: 100%;
        left: 0;
        bottom: -20px;
        right: 0;
        top: 0;
        margin: auto;
        text-align: center;
        font-size: 10px;
        padding-top: 0 !important;
        border-radius: 0 !important;
        background: none !important;
        color: var(--contrast-4);
        cursor: pointer;
    }



    .header.date{
        display: inline-flex;
        align-items: center;
        position: absolute;
        z-index: 10;
        background: none;
        left: 0;
        right: initial;
        width: initial;
        padding: 0 20px;
    }

    .header.date .label{
        color: var(--contrast-4);
        font-family: DistrictProLight;
        font-weight: 200;
    }

    .header.date .label.today{
        font-size: 15px;
        cursor:pointer;
    }

    .header.date .fa-angle-right,.header.date .fa-angle-left{
        color: var(--contrast-4);
        font-size: 20px;
        padding: 5px;
        cursor:pointer;
    }

    .header.date .fa-angle-right:hover,.header.date .fa-angle-left:hover, .header.date .fa-calendar:hover, .header.date .today:hover{
        color: var(--bg) !important;
    }

    .header.date .label.bold{
        font-family: DistrictProBold;
        font-weight: 800;
        margin: -3px 5px 0;
    }

    .header.date .fa-calendar{
        margin: 0 10px;
        font-size: 20px;
    }
    .timeframe.create{
        box-shadow: inset 0 0 0 1px var(--contrast-3);
        background: none;
    }


    .day .day-text{
        transform: scale(1) translateY(6px);
        transition: .2s;
        height: 37px;
        cursor: pointer;
    }

    .day .day-text:hover {
        transform: scale(1.3) translateY(1px);
    }

    .day .day-text * {
        pointer-events: none;
    }

    .sub-header{
        display: flex;
        justify-content: left;
        width: calc(100vw - 277px);
        left: 260px;
        height: 72px;
        position: fixed;
        top: 144px;
        background: var(--bg);
        box-shadow: 0 2px 0 -1px #d5d5d5;
        z-index: 12;
    }
    .sub-header .title{
        position: relative;
        display: flex;
        justify-content: center;
        padding: 0;
        align-self: flex-start;
        top: 1px;
    }

    .sub-header .title .label{
        font-size: 16px;
        font-weight: 500;
    }

    .sub-header .title .label.year{
        color: #6d8d23;;
        margin-right: 5px;
        font-weight: 800;
    }

    .project .background{
        position: absolute;
        top: 0;
        left: -100px;
        width: calc(100% + 100px);
        height: 100%;
        background: var(--bg);
        box-shadow: none;
        z-index: -1;
    }

    .project .background.shadow{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: calc(100% - 1px);
        background: var(--bg);
        z-index: -1;
        box-shadow: inset 0px -2px 0 -1px var(--contrast-1) !important;
    }


    .grid .row:hover .project .background.shadow{
        background: var(--contrast-2);
        border-radius: 0;
        border-top-left-radius: 100px;
        border-bottom-left-radius: 100px;
        box-shadow: none !important;
    }


    .event-marker{
        display: inline-block;
        height: 0;
        width: 0;
        font-size: 9px;
        text-align: center;
        padding-top: 2px;
        bottom: 26px;
        left: -2px;
        position: absolute;
        line-height: 110%;
        cursor: default;
        height: 13px;
        width: 10px;
        z-index: 1;
    }

    .always-work-bar{
        position: absolute;
        top: 0;
        height: 100%;
        background: #e5154f;
        z-index: -1;
        pointer-events: none;
    }

    .day-container.background{
        background: var(--bg);
        z-index: 12;
        margin-top: -12px;
    }



    .sub-header-button-container {
        width: 260px;
        height: 72px;
        padding-top: 42px;
        z-index: 13;
        position: fixed;
        background: var(--bg);
        top: 144px;
        box-shadow: 0 1px 1px 0 var(--contrast-1);
    }

    .sub-header-button-container > .button{
        margin: 0 0 0 15px !important;
       height: 25px !important;
       width: 25px !important;
       float: left;
       cursor: pointer;
        font-size: 17px;
        color: var(--contrast-4);
    }
    .sub-header-button-container > .button:first-of-type{
       float: left !important;
    }
    .sub-header-button-container > .button:last-of-type{
       float: right;
    }


    .tablecontainer{
        padding-left: 30px;
        padding-right: 30px;
    }

    .has-header > .has-header > .scrollbar-container{
        height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
        top: var(--header-height);
    }
    .header.top{
        margin: 10px 0;
    }
    .data-table{
        top: 10px;
        position: relative;
    }

    .header.date{
        display: inline-flex;
        justify-items: center;
        align-items: center;
        position: absolute;
        left: 20px;
    }

    .header.date .label{
        color: var(--contrast-4);
        font-family: DistrictProLight;
        font-weight: 200;
        margin-top: -3px;
    }

    .header.date .label.bold{
        font-family: DistrictProBold;
        font-weight: 800;
        margin-right: 5px;
        margin-top: -3px;
    }

    .header.date .fa-calendar{
        margin: 0 10px;
        font-size: 20px;
        margin-top: -3px;
    }
    .header.date .fa-angle-left{
        margin: 0 10px;
        font-size: 25px;
        color: var(--contrast-4);
    }
    .indicator-view{
        padding: 30px;
        padding-bottom: 50px;
    }
</style>
